export default __webpack_public_path__ + "static/patreon-b5726112e3233d5ffaf9c7b450c43de7.svg";